import client from "../modules/client";

export const getList = () => {
  return client(`/api/v2/categories`).then(({ data }) => data);
};

export function useCategoryService () {
  return {
    getList,
  };
}
